// 组件页面切换时，标记和移除页面名称
export default {
  data() {
    return {
      _scrollTop: 0
    }
  },
  created() {
    this.setBodyStyle()
  },
  activated() {
    this.bindBodyName('activated')
    // 切换页面时，回到初始位置或上次位置
    const scrollTop = this._scrollTop || 0;
    [document.body, document.documentElement].map(element => { element.scrollTop = scrollTop })
  },
  deactivated() {
    this.bindBodyName('deactivated')
    this._scrollTop = document.body.scrollTop
  },
  methods: {
    bindBodyName(action) {
      let bodyName = this.actionName || this.$options.componentName
      if (bodyName == null) return
      if (bodyName) bodyName = 'body-' + bodyName
      document.body.classList[action === 'activated' ? 'add' : 'remove'](bodyName)
    },
    setBodyStyle(styleValue) {
      const { style } = window.document.body;
      // 全局样式有变化的，跳过全局初始化
      if (this.updateStyle && styleValue == null) {
        return
      }
      styleValue = styleValue || this; // 可以指定样式
      ['backgroundColor', 'color'].forEach(styname => {
        const value = styleValue[styname]
        if (value) {
          if (styname) style[styname] = value
        }
      })
    }
  }
}